module.exports = __webpack_public_path__ + "static/mr-concert-performance-32-8c4ba0258aeaca40c374355cf3170167.jpg";